<template>
  <div>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- ダウンロードボタン -->
        <v-btn
          v-if="!readOnly"
          class="mx-2"
          color="primary"
          @click="handleDownload"
        >
          ダウンロード
        </v-btn>
        <!-- 編集ダイアログ -->
        <v-dialog v-model="dialog" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!readOnly"
              v-bind="attrs"
              v-on="on"
              class="mx-2"
              color="primary"
            >
              「新規登録」はこのボタンを押してください
            </v-btn>
          </template>
          <v-card>
            <v-form ref="form" v-model="valid">
              <v-card-title class="pb-0">
                <span class="headline">{{
                  $formTitle(
                    "原子力災害関係施設マスタ",
                    readOnly,
                    isNewEditedItem
                  )
                }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <p class="red--text mb-0">※：必須項目です</p>
                  <v-row v-if="isEditable('fa_name')">
                    <v-col cols="12">
                      <!-- 施設名 -->
                      <v-text-field
                        v-model="editedItem.fa_name"
                        label="施設名 ※"
                        :rules="readOnly ? [] : [rules.required()]"
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 40)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isEditable('fa_name_kana')">
                    <v-col cols="12">
                      <!-- 施設名（カナ） -->
                      <v-text-field
                        v-model="editedItem.fa_name_kana"
                        label="施設名（カナ） ※"
                        :rules="
                          readOnly ? [] : [rules.required(), rules.kana()]
                        "
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 60)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isEditable('fa_name_en')">
                    <v-col cols="12">
                      <!-- 施設名（英名） -->
                      <v-text-field
                        v-model="editedItem.fa_name_en"
                        label="施設名（英名） ※"
                        :rules="
                          readOnly
                            ? []
                            : [rules.required(), rules.enname('施設名（英名）')]
                        "
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 80)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col v-if="isEditable('facility_class')" cols="3">
                      <!-- 原子力防災施設区分 -->
                      <v-text-field
                        v-if="!(readOnly || isNewEditedItem)"
                        :value="
                          $facility.facilityClasses.find(
                            elem => elem.value === editedItem.facility_class
                          ).text
                        "
                        label="原子力防災施設区分 ※"
                        readonly
                      ></v-text-field>
                      <v-select
                        v-else
                        v-model="editedItem.facility_class"
                        :items="$facility.facilityClasses"
                        label="原子力防災施設区分 ※"
                        :clearable="false"
                        :rules="readOnly ? [] : [rules.required()]"
                        v-bind="formControlProps(config.PLACEHOLDER_SELECT)"
                      ></v-select>
                    </v-col>
                    <v-col v-if="isEditable('temp_facility_flg')" cols="3">
                      <!-- 臨時施設区分 -->
                      <v-select
                        v-model="editedItem.temp_facility_flg"
                        :items="$facility.tempFacilityFlags"
                        label="臨時施設区分 ※"
                        :clearable="false"
                        :rules="readOnly ? [] : [rules.required()]"
                        v-bind="formControlProps(config.PLACEHOLDER_SELECT)"
                      ></v-select>
                    </v-col>
                    <v-col v-if="isEditable('organize_id')" cols="3">
                      <!-- 組織名 -->
                      <v-autocomplete
                        v-model="editedItem.organize_id"
                        :items="organizations"
                        item-text="organize_name"
                        item-value="organize_id"
                        label="組織名 ※"
                        :clearable="false"
                        :rules="readOnly ? [] : [rules.required()]"
                        v-bind="formControlProps(config.PLACEHOLDER_SELECT)"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="isEditable('lodine_distri_place_flg')">
                    <v-col>
                      <!-- 安定ヨウ素剤配布場所に設定(1: 配布場所、0: 配布場所でない) -->
                      <v-checkbox
                        v-model="editedItem.lodine_distri_place_flg"
                        label="安定ヨウ素剤配布場所に設定"
                        true-value="1"
                        false-value="0"
                        :readonly="readOnly"
                        dense
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row v-if="isEditable('lanes')">
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field
                        :value="editedItem.lanes"
                        @input="editedItem.lanes = $event ? $event : ''"
                        label="レーン数"
                        :rules="readOnly ? [] : [rules.numeric()]"
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 4)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      isEditable('max_capacity') && isEditable('max_household')
                    "
                  >
                    <v-col cols="3">
                      <!-- 最大収容人数 -->
                      <v-text-field
                        :value="editedItem.max_capacity"
                        @input="editedItem.max_capacity = $event ? $event : ''"
                        label="最大収容人数"
                        suffix="人"
                        :rules="readOnly ? [] : [rules.numeric()]"
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 4)"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <!-- 最大収容世帯数 -->
                      <v-text-field
                        :value="editedItem.max_household"
                        @input="editedItem.max_household = $event ? $event : ''"
                        label="最大収容世帯数"
                        suffix="世帯"
                        :rules="readOnly ? [] : [rules.numeric()]"
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 4)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isEditable('designated_category')">
                    <v-col cols="6">
                      <!-- 指定区分 -->
                      <v-select
                        v-model="editedItem.designated_category"
                        :items="$facility.designatedCategories"
                        label="指定区分 ※"
                        :rules="readOnly ? [] : [rules.required()]"
                        v-bind="formControlProps(config.PLACEHOLDER_SELECT)"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="isEditable('ju_municip_code')">
                    <v-col cols="3">
                      <!-- 市町村 -->
                      <v-select
                        v-model="editedItem.ju_municip_code"
                        :items="municipalities"
                        label="市町村 ※"
                        :rules="readOnly ? [] : [rules.required()]"
                        v-bind="formControlProps(config.PLACEHOLDER_SELECT)"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="isEditable('eva_area_info')">
                    <v-col cols="12">
                      <eva-area-info
                        :eva-area-info="editedItem.eva_area_info"
                        :municipalities="municipalities"
                        :areas="$store.state.allArea.areas"
                        :read-only="this.readOnly"
                        :facility-class="editedItem.facility_class"
                        :facility-id="editedItem.fa_id"
                        :edited-eva-area-info.sync="
                          editedItem.edited_eva_area_info
                        "
                        ref="evaAreaInfo"
                      />
                    </v-col>
                  </v-row>
                  <v-row v-if="isEditable('fa_respons_person')">
                    <v-col cols="12">
                      <!-- 施設管理者 -->
                      <v-text-field
                        :value="editedItem.fa_respons_person"
                        @input="
                          editedItem.fa_respons_person = $event ? $event : ''
                        "
                        label="施設管理者"
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 40)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isEditable('fa_phone')">
                    <v-col cols="6">
                      <!-- 連絡先電話番号 -->
                      <v-text-field
                        :value="editedItem.fa_phone"
                        @input="editedItem.fa_phone = $event ? $event : ''"
                        label="連絡先電話番号"
                        :rules="readOnly ? [] : [rules.phone()]"
                        v-bind="
                          formControlProps(
                            config.PLACEHOLDER_INPUT,
                            20,
                            config.HINT_TEL_AND_EXTENSION_WITH_HYPHEN
                          )
                        "
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isEditable('fa_fax')">
                    <v-col cols="6">
                      <!-- 連絡先FAX -->
                      <v-text-field
                        :value="editedItem.fa_fax"
                        @input="editedItem.fa_fax = $event ? $event : ''"
                        label="連絡先FAX"
                        :rules="readOnly ? [] : [rules.phone()]"
                        v-bind="
                          formControlProps(
                            config.PLACEHOLDER_INPUT,
                            20,
                            config.HINT_TEL_AND_EXTENSION_WITH_HYPHEN
                          )
                        "
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isEditable('fa_mail_address')">
                    <v-col cols="12">
                      <!-- 連絡先メールアドレス -->
                      <v-text-field
                        :value="editedItem.fa_mail_address"
                        @input="
                          editedItem.fa_mail_address = $event ? $event : ''
                        "
                        label="連絡先メールアドレス"
                        :rules="readOnly ? [] : [rules.mail()]"
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 100)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isEditable('fa_address')">
                    <v-col cols="12">
                      <!-- 施設住所 -->
                      <v-text-field
                        :value="editedItem.fa_address"
                        @input="editedItem.fa_address = $event ? $event : ''"
                        label="施設住所"
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 40)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isEditable('fa_address_en')">
                    <v-col cols="12">
                      <!-- 施設住所（英名） -->
                      <v-text-field
                        :value="editedItem.fa_address_en"
                        @input="editedItem.fa_address_en = $event ? $event : ''"
                        label="施設住所（英名）"
                        :rules="
                          readOnly ? [] : [rules.enname('施設住所（英名）')]
                        "
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 80)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      isEditable('fa_latitude') && isEditable('fa_longitude')
                    "
                  >
                    <v-col v-if="!readOnly" cols="12">
                      <p class="black--text">
                        緯度・経度は、DEG形式(10進表記)で入力します。小数部6桁まで入力可能です。<br />
                        <span>緯度の記入例：31.560195</span
                        ><span class="pl-8">経度の記入例：130.557964</span>
                      </p>
                    </v-col>
                    <v-col cols="3">
                      <!-- 緯度 -->
                      <v-text-field
                        v-model="editedItem.fa_latitude"
                        :value="editedItem.fa_latitude"
                        @input="editedItem.fa_latitude = $event ? $event : ''"
                        label="緯度"
                        :rules="
                          readOnly
                            ? []
                            : [
                                rules.numeric(false, true),
                                rules.decimal(2, 6),
                                rules.range(0, 90)
                              ]
                        "
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 10)"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <!-- 経度 -->
                      <v-text-field
                        v-model="editedItem.fa_longitude"
                        :value="editedItem.fa_longitude"
                        @input="editedItem.fa_longitude = $event ? $event : ''"
                        label="経度"
                        :rules="
                          readOnly
                            ? []
                            : [
                                rules.numeric(false, true),
                                rules.decimal(3, 6),
                                rules.range(0, 180)
                              ]
                        "
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 11)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <v-row
                    v-if="
                      isEditable('fa_distance_from_npp') &&
                        isEditable('fa_direction_from_npp')
                    "
                  >
                    <v-col cols="3">
                      <!-- 原発からの距離 -->
                      <v-text-field
                        v-model="editedItem.fa_distance_from_npp"
                        :value="editedItem.fa_distance_from_npp"
                        :placeholder="config.PLACEHOLDER_SP"
                        label="原発からの直線距離 (km)"
                        disabled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <!-- 原発からの方角 -->
                      <v-text-field
                        v-model="editedItem.fa_direction_from_npp"
                        :value="editedItem.fa_direction_from_npp"
                        :placeholder="config.PLACEHOLDER_SP"
                        label="原発からの方角"
                        disabled
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isEditable('dpnd_fa_id')">
                    <v-col cols="3">
                      <!-- DPND施設ID -->
                      <v-text-field
                        v-model="editedItem.dpnd_fa_id"
                        :placeholder="config.PLACEHOLDER_SP"
                        label="DPND施設ID"
                        readonly
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="!readOnly"
                  class="mx-2"
                  color="primary"
                  :loading="loading"
                  :disabled="!valid"
                  @click="handleSaveEditDialog"
                >
                  {{ isNewEditedItem ? "登録" : "更新" }}
                </v-btn>
                <v-btn
                  class="mx-2"
                  color="primary"
                  :disabled="loading"
                  @click="handleCloseEditDialog"
                >
                  {{ $cancelButtonText(readOnly) }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p style="margin: 5px 0 15px 0;">
          原子力災害関係施設マスタは下の表を参照してください。条件を指定することで一覧から絞り込むことができます。
        </p>
        <v-row>
          <v-col cols="6" md="3">
            <!-- 検索項目：原子力防災施設区分 -->
            <v-select
              v-model="searchItem.facilityClass"
              :items="$facility.facilityClasses"
              label="原子力防災施設区分"
              :placeholder="config.PLACEHOLDER_SELECT"
              outlined
              hide-details
            >
            </v-select>
          </v-col>
          <v-col cols="6" md="3">
            <!-- 検索項目：臨時施設区分 -->
            <v-select
              v-model="searchItem.tempFacilityFlag"
              :items="$facility.tempFacilityFlags"
              label="臨時施設区分"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
              hide-details
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="3">
            <!-- 検索項目：市町村または避難元所属市町村 -->
            <v-select
              v-model="searchItem.municipality"
              :items="municipalitiesAddAll"
              :label="municipalityTitle(searchItem.facilityClass)"
              :placeholder="config.PLACEHOLDER_SELECT"
              outlined
              hide-details
            >
            </v-select>
          </v-col>
          <v-col cols="6" md="3">
            <!-- 検索項目：避難元所属地域（地区） -->
            <v-select
              v-if="showsArea"
              v-model="searchItem.area"
              :items="$facility.areasForSearch(areas)"
              :label="areaTitle(searchItem.facilityClass)"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="6" md="6">
            <!-- 未設定項目アラート -->
            <p
              v-if="!readOnly && hasUnsetItem"
              class="red--text text-body-2 my-2"
            >
              必須項目未設定のマスタが存在します。<br />
              「未設定項目がある施設のみ表示」にチェックを入れて表示された明細を編集してください。
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <!-- 検索項目：未設定項目あり -->
            <v-checkbox
              class="shrink mr-0 mt-0"
              v-model="searchItem.showsUnsetOnly"
              label="未設定項目がある施設のみ表示"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <!-- 検索項目：安定ヨウ素剤配布場所のみ -->
            <v-checkbox
              class="shrink mr-0 mt-0"
              v-model="searchItem.showsDistriPlaceOnly"
              label="安定ヨウ素剤配布場所のみ表示"
              hide-details
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <p class="grey--text">
              部分一致で検索することができます。<br />
              検索は施設名、施設名（カナ）、施設名（英名）、施設住所、施設管理者の項目が対象です。<br />
              スペースを挟み、複数の語句で検索することはできません。<br />
            </p>
          </v-col>
          <v-col cols="12">
            <!-- 検索項目：フリーテキスト -->
            <v-text-field
              v-model="searchItem.freeText"
              label="フリーテキスト"
              placeholder="施設名、施設名（カナ）、施設名（英名）、施設住所、施設管理者から検索"
              clearable
              append-icon="mdi-magnify"
              outlined
              hide-details
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-divider class="mb-1"></v-divider>
      </v-container>
      <!-- 一覧表 -->
      <top-operation-data-table
        ref="table"
        v-if="showsDataTable"
        :headers="headers"
        :items="filteredItems"
        locale="ja-jp"
        item-key="fa_id"
        sort-by="fa_name_kana"
        rowCount="-1"
        must-sort
      >
        <!-- -->
        <template v-slot:[`item.fa_name`]="{ item }">
          {{ $facility.facilityName(item) }}
        </template>
        <template v-slot:[`item.fa_name_kana`]="{ item }">
          {{ $facility.facilityNameKana(item) }}
        </template>
        <template v-slot:[`item.fa_name_en`]="{ item }">
          {{ $facility.facilityNameEn(item) }}
        </template>
        <template v-slot:[`item.facility_class`]="{ item }">
          {{ $facility.facilityClassName(item) }}
        </template>
        <template v-slot:[`item.temp_facility_flg`]="{ item }">
          {{ $facility.tempFacilityFlagName(item) }}
        </template>
        <template v-slot:[`item.eva_municip_code_list`]="{ item }">
          {{ municipalityNames(item) }}
        </template>
        <template v-slot:[`item.eva_area_code_list`]="{ item }">
          {{ areaNames(item) }}
        </template>
        <template v-slot:[`item.ju_municip_code`]="{ item }">
          {{ municipalityNames(item) }}
        </template>
        <template v-slot:[`item.max_capacity`]="{ item }">
          {{ item.max_capacity | format }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <template v-if="readOnly">
            <v-btn small class="mx-2" color="primary" @click="handleView(item)"
              >参照</v-btn
            >
          </template>
          <template v-else>
            <v-btn small class="mx-2" color="primary" @click="handleEdit(item)"
              >編集</v-btn
            >
            <v-btn
              small
              class="mx-2"
              color="primary"
              @click="handleDelete(item)"
              >削除</v-btn
            >
          </template>
        </template>
      </top-operation-data-table>
    </v-sheet>
    <!-- ダイアログ -->
    <confirm-dialog ref="confirmDialog" />
    <!-- オーバーレイ -->
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import cloneDeep from "lodash/cloneDeep";
import ConfirmDialog from "@/components/ConfirmDialog";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import config from "@/js/const";
import Facility from "@/plugins/facility";
import FormUtils from "@/plugins/form-utils";
import { ScreenId } from "@/js/value-objects/screen-id";
import { FacilityClass } from "@/js/value-objects/facility-class";
import messageUtils from "@/mixins/message-utils";
import { AllAreaTranslator } from "@/js/translators/allAreaTranslator";
import Validation from "@/plugins/validation";
import { FacilityTranslator } from "@/js/translators/facilityTranslator";
import { fileDownload } from "@/js/utils";

Vue.use(Facility, FormUtils, Validation);

const organizeMstRepository = RepositoryFactory.get("organizeMst");
const disasterPreventionFaRepository = RepositoryFactory.get(
  "disasterPreventionFa"
);

// DPND連携で未設定として扱う組織ID
const DEFAULT_DPND_ORGANIZE_ID = "OIDPND";
// DPND連携で未設定として扱う市町村コード
const DEFAULT_DPND_MUNICIP_CODE = "000000";
// DPND連携で未設定として扱う地域コード
const DEFAULT_DPND_AREA_CODE = "00000000";
// DPND連携で未設定として扱う指定区分ID
const DEFAULT_DPND_DESIGNATED = "0";
// DPND連携で未設定として扱うレーン数
const DEFAULT_DPND_LANES = "0";
// 原発からの距離計算で使用する地球の半径
const EARTH_RADIUS = 6371;
// 原発からの方角計算で使用する方角
const directions = [
  "北",
  "北北東",
  "北東",
  "東北東",
  "東",
  "東南東",
  "南東",
  "南南東",
  "南",
  "南南西",
  "南西",
  "西南西",
  "西",
  "西北西",
  "北西",
  "北北西"
];

/**
 * バリデーションルールを作成する。
 * @function
 * @returns {Object} バリデーションルール
 */
const getRules = () => ({
  /**
   * 必須チェックルールを作成する
   * @function
   * @returns 必須チェックルール
   */
  required: () => v => !!v || "必須項目です。",

  /**
   * 数値チェックルールを作成する
   * @function
   * @param {boolean} [acceptNegative=false] 負数(マイナス記号)の入力を許容するかどうか
   * @param {booealn} [acceptFloat=false] 小数の入力を許容するかどうか
   * @returns 数値チェックルール
   */
  numeric: (
    acceptNegative = false,
    acceptFloat = false,
    pattern = new RegExp(
      `^${acceptNegative ? "-?" : ""}\\d+${acceptFloat ? "(\\.\\d+)?" : ""}$`
    )
  ) => v => !v || pattern.test(v) || "数値で入力してください",

  /**
   * 小数点数の整数部と小数部の桁数チェックルールを作成する
   * @function
   * @param {number} digit 整数部の桁数
   * @param {number} scale 小数部の桁数
   * @returns 小数点数の桁数チェックルール
   */
  decimal: (
    digit,
    scale,
    pattern = new RegExp(`^-?\\d{1,${digit}}(\\.\\d{1,${scale}})?$`)
  ) => v =>
    !v ||
    pattern.test(v) ||
    `整数部${digit}桁以内、小数部${scale}桁以内で入力してください。`,

  /**
   * 数値範囲チェックルールを作成する
   * @function
   * @param {number} min 最小値(以上)
   * @param {number} max 最大値(以下)
   * @returns 数値範囲チェックルール
   */
  range: (min, max) => v => {
    if (!v) {
      return true;
    }

    const value = Number(v);
    if (value >= min && value <= max) {
      return true;
    }

    return `既定の範囲内(${min}~${max})数値を入力してください。`;
  },

  /**
   * 英名チェックルールを作成する。
   * @function
   * @param {string} name エラーメッセージに表示する項目名
   */
  enname: name => v =>
    /^[ a-zA-Z0-9!-/:-@¥[-`{-~]*$/.test(v) ||
    `${name}を正しく入力してください。`,

  /**
   * 全角カナ入力チェックルールを作成する
   * @function
   * @returns 全角カナ入力チェックルール
   */
  kana: () => v =>
    !v ||
    /^[ァ-ヶ\u3000 －―‐ー「」（）・]+$/.test(v) ||
    "全角カナ文字を入力してください。",

  /**
   * メールアドレスの入力チェックルールを作成する
   * @function
   * @returns メールアドレス入力チェックルール
   */
  mail: () => v =>
    !v ||
    /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{2,}$/.test(
      v
    ) ||
    "「@(アットマーク)」を含んだ正しいメールアドレスの形式で入力してください。",

  /**
   * 電話番号の入力チェックルールを作成する
   * @function
   * @returns 電話番号の入力チェックルール
   */
  phone: () => v =>
    /^[\d()-]*$/.test(v) || "正しい電話(FAX)番号の形式で入力してください。"
});

/**
 * 一覧表のヘッダーを作成する。
 * @function
 * @param {string} facilityClass 原子力防災施設区分
 * @returns 一覧表のヘッダー
 */
const getHeaders = facilityClass => {
  // 原子力防災施設区分毎のヘッダー
  const facilityClassHeaders = {
    // 避難所
    [FacilityClass.SHELTER]: [
      {
        text: "避難元所属\n市町村",
        value: "eva_municip_code_list",
        align: "pre",
        class: "text-pre",
        sortable: false
      },
      {
        text: "避難元所属\n地域（地区）",
        value: "eva_area_code_list",
        align: "pre",
        class: "text-pre",
        sortable: false
      },
      {
        text: "最大収容人数",
        value: "max_capacity"
      }
    ],
    // 一時集合場所
    [FacilityClass.MEETING]: [
      {
        text: "避難元所属\n市町村",
        value: "eva_municip_code_list",
        align: "pre",
        class: "text-pre",
        sortable: false
      },
      {
        text: "避難元所属\n地域（地区）",
        value: "eva_area_code_list",
        align: "pre",
        class: "text-pre",
        sortable: false
      },
      {
        text: "最大収容人数",
        value: "max_capacity"
      }
    ],
    // 避難退域時検査場所
    [FacilityClass.INSPECTION]: [
      {
        text: "市町村",
        value: "ju_municip_code"
      },
      {
        text: "レーン数",
        value: "lanes"
      }
    ]
  };

  return [
    {
      text: "施設ID",
      value: "fa_id",
      align: " d-none"
    },
    {
      text: "施設名",
      value: "fa_name"
    },
    {
      text: "施設名（カナ）",
      value: "fa_name_kana"
    },
    {
      text: "施設名（英名）",
      value: "fa_name_en"
    },
    {
      text: "原子力防災施設区分",
      value: "facility_class"
    },
    {
      text: "臨時施設\n区分",
      value: "temp_facility_flg",
      class: "text-pre"
    },
    ...facilityClassHeaders[
      facilityClass ? facilityClass : FacilityClass.SHELTER
    ],
    {
      text: "操作",
      value: "actions",
      width: "14.5em",
      sortable: false
    }
  ];
};

/**
 * 未設定判定対象の項目名と判定条件を作成する。
 * @function
 * @param {string} facilityClass 原子力防災施設区分
 * @returns 未設定判定対象の項目名と判定条件
 */
const getUnsetTargets = facilityClass => {
  // 判定条件
  const isFalsy = value => !value;
  const isFalsyOrEqualsTo = target => value =>
    isFalsy(value) || target === value;
  const isFalsyOrIncludes = target => value =>
    isFalsy(value) ||
    value.length === 0 ||
    value.some(element => element === target);

  const isFalsyOrDefaultOrganizeId = isFalsyOrEqualsTo(
    DEFAULT_DPND_ORGANIZE_ID
  );
  const isFalsyOrDefaultMunicipCode = isFalsyOrIncludes(
    DEFAULT_DPND_MUNICIP_CODE
  );
  const isFalsyOrDefaultAreaCode = isFalsyOrIncludes(DEFAULT_DPND_AREA_CODE);
  const isFalsyOrDefaultDesignated = isFalsyOrEqualsTo(DEFAULT_DPND_DESIGNATED);
  const isFalsyOrDefaultLanes = isFalsyOrEqualsTo(DEFAULT_DPND_LANES);

  // 原子力防災施設区分毎の項目名と判定条件
  const facilityClassTargets = {
    // 避難所
    [FacilityClass.SHELTER]: [
      { name: "designated_category", criteria: isFalsyOrDefaultDesignated },
      { name: "eva_municip_code_list", criteria: isFalsyOrDefaultMunicipCode },
      { name: "eva_area_code_list", criteria: isFalsyOrDefaultAreaCode }
    ],
    // 一時集合場所
    [FacilityClass.MEETING]: [
      { name: "ju_municip_code", criteria: isFalsy },
      { name: "eva_municip_code_list", criteria: isFalsyOrDefaultMunicipCode },
      { name: "eva_area_code_list", criteria: isFalsyOrDefaultAreaCode }
    ],
    // 避難退域時検査場所
    [FacilityClass.INSPECTION]: [
      { name: "ju_municip_code", criteria: isFalsy },
      { name: "lanes", criteria: isFalsyOrDefaultLanes }
    ]
  };

  return [
    { name: "fa_name", criteria: isFalsy },
    { name: "fa_name_kana", criteria: isFalsy },
    { name: "fa_name_en", criteria: isFalsy },
    { name: "facility_class", criteria: isFalsy },
    { name: "temp_facility_flg", criteria: isFalsy },
    { name: "organize_id", criteria: isFalsyOrDefaultOrganizeId },
    ...(facilityClassTargets[facilityClass] ?? [])
  ];
};

/**
 * 空の避難元所属地域情報を1つ保持する配列を作成する。
 * （CSVダウンロードの前処理）
 * @function
 * @returns 空の避難元所属地域情報
 */
const createEmptyEvaAreaInfoForCSV = () => [
  {
    eva_area_code: "",
    eva_area_name: "",
    eva_municip_code: "",
    eva_municip_name: ""
  }
];

/**
 * 避難元所属地域情報が存在しない場合、空の避難元所属地域情報を追加する。
 * （CSVダウンロードの前処理）
 * @function
 */
const addEmptyEvaAreaInfoIfNeeded = ({ eva_area_info = null, ...rest }) => ({
  ...rest,
  eva_area_info:
    Array.isArray(eva_area_info) && eva_area_info.length > 0
      ? eva_area_info
      : createEmptyEvaAreaInfoForCSV()
});

/**
 * 原子力災害関係施設情報×避難元所属地域情報数分のレコードに平坦化する。
 * （CSVダウンロードの前処理）
 * @function
 */
const flatternEvaAreaInfo = ({ eva_area_info, ...rest }) =>
  eva_area_info.map(eva_area_info_elem => ({ ...rest, ...eva_area_info_elem }));

/**
 * CSVのヘッダ名と属性名リスト
 */
const CSV_FIELDS = [
  { name: "施設ID", attr: "fa_id" },
  { name: "施設名", attr: "fa_name" },
  { name: "施設名（カナ）", attr: "fa_name_kana" },
  { name: "施設名（英名）", attr: "fa_name_en" },
  { name: "原子力防災施設区分ID", attr: "facility_class" },
  { name: "原子力防災施設区分", attr: "facility_class_val" },
  { name: "臨時施設区分ID", attr: "temp_facility_flg" },
  { name: "臨時施設区分", attr: "temp_facility_flg_val" },
  { name: "組織ID", attr: "organize_id" },
  { name: "組織名", attr: "organize_name" },
  { name: "安定ヨウ素剤配布場所に設定ID", attr: "lodine_distri_place_flg" },
  { name: "安定ヨウ素剤配布場所に設定", attr: "lodine_distri_place_flg_val" },
  { name: "最大収容人数", attr: "max_capacity" },
  { name: "最大収容世帯数", attr: "max_household" },
  { name: "指定区分ID", attr: "designated_category" },
  { name: "指定区分", attr: "designated_category_val" },
  { name: "レーン数", attr: "lanes" },
  { name: "市町村コード", attr: "ju_municip_code" },
  { name: "市町村名", attr: "ju_municip_name" },
  { name: "施設管理者", attr: "fa_respons_person" },
  { name: "連絡先電話番号", attr: "fa_phone" },
  { name: "連絡先FAX", attr: "fa_fax" },
  { name: "連絡先メールアドレス", attr: "fa_mail_address" },
  { name: "施設住所", attr: "fa_address" },
  { name: "施設住所（英）", attr: "fa_address_en" },
  { name: "緯度", attr: "fa_latitude" },
  { name: "経度", attr: "fa_longitude" },
  { name: "原発からの距離", attr: "fa_distance_from_npp" },
  { name: "原発からの方角", attr: "fa_direction_from_npp" },
  { name: "原発からの方角（英）", attr: "fa_direction_from_npp_en" },
  { name: "DPND施設ID", attr: "dpnd_fa_id" },
  { name: "避難元所属市町村コード", attr: "eva_municip_code" },
  { name: "避難元所属市町村名", attr: "eva_municip_name" },
  { name: "避難元所属地域コード", attr: "eva_area_code" },
  { name: "避難元所属地域名", attr: "eva_area_name" }
];

/**
 * CSVの行を結合する関数を作成する。
 * @function
 * @param {string} [separator=\n] 行の区切り文字
 * @returns 区切り文字で行を結合する関数
 */
const getCSVRowJoiner = (separator = "\n") => lines =>
  `${lines.join(separator)}${separator}`;

/**
 * CSVの列を結合する関数を作成する。
 * @function
 * @param {string} [separator=,] 列の区切り文字
 * @param {string} [quote="] 値を囲う文字
 * @returns 区切り文字で列を結合する関数
 */
const getCSVColJoiner = (separator = ",", quote = '"') => fields =>
  fields.map(field => quote + field + quote).join(separator);

/**
 * 2次元配列をCSVテキストに変換する関数を作成する。
 * @function
 * @param {rowJoiner} 行結合関数
 * @param {colJoiner} 列結合関数
 */
const getCSVFormatter = (
  rowJoiner = getCSVRowJoiner(),
  colJoiner = getCSVColJoiner(),
  bom = "\ufeff"
) => records => bom + rowJoiner(records.map(colJoiner));

/**
 * CSV出力時の並び替え関数
 * 施設ID、避難元所属市町村コード、避難元所属地域コードの昇順で並び替える。
 *
 * @function
 * @param {object} a 比較対象。APIの戻り値オブジェクト
 * @param {object} b 比較対象。APIの戻り値オブジェクト
 * @returns aの方が小さい場合は -1、大きい場合は 1、その他の場合は 0。
 */
const csvSorter = (a, b) => {
  if (a.fa_id === b.fa_id) {
    if (a.eva_municip_code === b.eva_municip_code) {
      if (a.eva_area_code === b.eva_area_code) {
        return 0;
      }
      return a.eva_area_code < b.eva_area_code ? -1 : 1;
    }
    return a.eva_municip_code < b.eva_municip_code ? -1 : 1;
  }
  return a.fa_id < b.fa_id ? -1 : 1;
};

/**
 * オブジェクトを配列に変換する関数を作成する。
 * @function
 * @param {string[]} order 配列が対応する属性名リスト
 * @returns オブジェクトを属性名リストにしたがって配列に変換する関数
 */
const toCSVColArray = (order = CSV_FIELDS.map(({ attr }) => attr)) => items =>
  order.map(key => items[key]);

/**
 * タイムスタンプ文字列(YYYYMMDD_HHMM)を作成する。
 * @param {Date} [date=new Date()] 文字列に変換対象の日付。
 * @returns タイムスタンプ文字列
 */
const getTimestamp = (date = new Date()) => {
  const padZero = value => value.toString().padStart(2, "0");

  const dateText = [date.getMonth() + 1, date.getDate()].map(padZero).join("");
  const timeText = [date.getHours(), date.getMinutes()].map(padZero).join("");

  return `${date.getFullYear()}${dateText}_${timeText}`;
};

/**
 * 編集可能な属性名のリストを作成する。
 * @function
 * @param {string} facilityClass 原子力防災施設区分
 * @returns 属性名のリスト
 */
const getEditableAttributes = facilityClass => {
  // 原子力防災施設区分毎の属性名リスト
  const facilityClassAttributes = {
    // 避難所
    [FacilityClass.SHELTER]: [
      "max_capacity",
      "max_household",
      "designated_category",
      "eva_area_info"
    ],
    // 一時集合場所
    [FacilityClass.MEETING]: ["max_capacity", "max_household", "eva_area_info"],
    // 避難退域時検査場所
    [FacilityClass.INSPECTION]: ["lanes"]
  };

  return [
    "fa_name",
    "fa_name_kana",
    "fa_name_en",
    "facility_class",
    "temp_facility_flg",
    "organize_id",
    "lodine_distri_place_flg",
    "ju_municip_code",
    "fa_respons_person",
    "fa_phone",
    "fa_fax",
    "fa_mail_address",
    "fa_address",
    "fa_address_en",
    "fa_latitude",
    "fa_longitude",
    "fa_distance_from_npp",
    "fa_direction_from_npp",
    "dpnd_fa_id",
    ...(facilityClassAttributes[facilityClass] ?? [])
  ];
};

/**
 * 空の避難元所属地域情報を1つ保持する配列を作成する。
 * @function
 * @returns 空の避難元所属地域情報
 */
const createEmptyEvaAreaInfo = () => [
  {
    key: 1,
    eva_municip_code: "",
    eva_area_code: ""
  }
];

/**
 * 空の編集アイテムを作成する。
 * @function
 * @returns 空の編集アイテム
 */
const createEditedItem = () => ({
  fa_name: "",
  fa_name_kana: "",
  fa_name_en: "",
  facility_class: "",
  temp_facility_flg: "",
  organize_name: "",
  lodine_distri_place_flg: "0",
  lanes: "",
  max_capacity: "",
  max_household: "",
  designated_category: "",
  ju_municip_code: "",
  eva_area_info: [],
  edited_eva_area_info: createEmptyEvaAreaInfo(),
  fa_respons_person: "",
  fa_phone: "",
  fa_fax: "",
  fa_mail_address: "",
  fa_address: "",
  fa_address_en: "",
  fa_latitude: "",
  fa_longitude: "",
  fa_distance_from_npp: "",
  fa_direction_from_npp: "",
  dpnd_fa_id: ""
});

/**
 * APIのレスポンスを編集アイテムに変換する。
 * @function
 * @param {object} item APIのレスポンスオブジェクト
 * @param {object[]} item.eva_area_info 避難元所属地域情報
 * @returns {object} 編集アイテム
 */
const convertEditable = ({ eva_area_info = null, ...rest }) => {
  const result = {
    // デフォルトアイテム
    ...createEditedItem(),
    // eva_area_info 以外を上書き
    ...rest
  };

  // eva_area_info の設定
  if (Array.isArray(eva_area_info) && eva_area_info.length > 0) {
    result.eva_area_info = cloneDeep(eva_area_info);
    result.edited_eva_area_info = cloneDeep(eva_area_info);
  }

  // セレクトボックスに表示する値は、DPND連携の初期値を置き換える。
  // ルートオブジェクトの置換対象
  const dpndRootColumns = [
    ["organize_id", DEFAULT_DPND_ORGANIZE_ID],
    ["designated_category", DEFAULT_DPND_DESIGNATED]
  ];
  // eva_area_info 配列要素の置換対象
  const dpndEvaAreaInfoColumns = [
    ["eva_municip_code", DEFAULT_DPND_MUNICIP_CODE],
    ["eva_area_code", DEFAULT_DPND_AREA_CODE]
  ];

  const dpndDefaultValueConverter = (targets, replace = "") => item => {
    for (const [name, value] of targets) {
      if (item[name] === value) {
        item[name] = replace;
      }
    }
  };
  const rootConverter = dpndDefaultValueConverter(dpndRootColumns);
  const evaAreaConverter = dpndDefaultValueConverter(dpndEvaAreaInfoColumns);

  rootConverter(result);
  result.eva_area_info.forEach(evaAreaConverter);
  result.edited_eva_area_info.forEach(evaAreaConverter);

  return result;
};

/**
 * 組織リストを取得する。
 * @param {string} screenId 画面ID
 * @returns {object[]} 組織リスト
 */
const fetchOrganizations = async screenId => {
  return (await organizeMstRepository.list(screenId)).data.results;
};

/**
 * 原子力災害関係施設マスタを取得する。
 * @param {string} screenId 画面ID
 * @param {string} [municipCode=""] 市町村コード(省略時は全件)
 * @returns {object[]} 原子力災害関係施設リスト
 */
const fetchDisasterFacilities = async (screenId, municipCode = "") =>
  (
    await disasterPreventionFaRepository.list(screenId, municipCode)
  ).data.results.map(element =>
    // facilityStore.loadFacility の実装を移植
    // 一時避難所の場合、以下の属性を編集または追加する。
    // * eva_area_info: 要素を市町村コード、エリアコードでソート
    // * eva_area_info[].key: ソート後のインデックス+1を追加
    // * eva_municip_code_list: eva_area_info[].eva_municip_code のリストを追加
    // * eva_area_code_list: eva_area_info[].eva_area_code のリストを追加
    element.facility_class === FacilityClass.SHELTER ||
    element.facility_class === FacilityClass.MEETING
      ? {
          ...element,
          ...FacilityTranslator.toEveMunicipalitiesAndEveAreasFromEvaAreaInfo(
            element.eva_area_info
          )
        }
      : element
  );

/**
 * 避難所の登録または更新リクエスト用のペイロードを作成する
 * @function
 * @param {object} editedItem 編集アイテム
 * @returns {object} ペイロード
 */
const toCreateOrUpdatePayloadForShelter = ({
  fa_id = undefined,
  fa_name = "",
  fa_name_en = "",
  fa_name_kana = "",
  organize_id = "",
  fa_address = "",
  fa_address_en = "",
  ju_municip_code = "",
  fa_phone = "",
  fa_fax = "",
  fa_mail_address = "",
  fa_latitude = "",
  fa_longitude = "",
  fa_distance_from_npp = "",
  fa_direction_from_npp = "",
  fa_respons_person = "",
  max_capacity = "",
  max_household = "",
  lodine_distri_place_flg = "",
  temp_facility_flg = "",
  designated_category = "",
  edited_eva_area_info = [],
  hash = undefined
} = {}) => ({
  facility_class: FacilityClass.SHELTER, // 避難所
  fa_id,
  fa_name,
  fa_name_en,
  fa_name_kana,
  organize_id,
  evadist_municip_code: ju_municip_code,
  fa_address,
  fa_address_en,
  ju_municip_code,
  fa_phone,
  fa_fax,
  fa_mail_address,
  fa_latitude,
  fa_longitude,
  fa_distance_from_npp,
  fa_direction_from_npp,
  fa_respons_person,
  max_capacity,
  max_household,
  lodine_distri_place_flg,
  temp_facility_flg,
  designated_category,
  eva_area_info: edited_eva_area_info
    .filter(
      ({ eva_municip_code, eva_area_code }) => eva_municip_code && eva_area_code
    )
    .map(({ eva_municip_code, eva_area_code }) => ({
      eva_municip_code,
      eva_area_code
    })),
  hash
});

/**
 * 一時集合場所の登録または更新リクエスト用のペイロードを作成する
 * @function
 * @param {object} editedItem 編集アイテム
 * @returns {object} ペイロード
 */
const toCreateOrUpdatePayloadForMeeting = ({
  fa_id = undefined,
  fa_name = "",
  fa_name_en = "",
  fa_name_kana = "",
  organize_id = "",
  fa_address = "",
  fa_address_en = "",
  ju_municip_code = "",
  fa_phone = "",
  fa_fax = "",
  fa_mail_address = "",
  fa_latitude = "",
  fa_longitude = "",
  fa_distance_from_npp = "",
  fa_direction_from_npp = "",
  fa_respons_person = "",
  max_capacity = "",
  max_household = "",
  lodine_distri_place_flg = "",
  temp_facility_flg = "",
  edited_eva_area_info = [],
  hash = undefined
} = {}) => ({
  facility_class: FacilityClass.MEETING, // 一時集合場所
  fa_id,
  fa_name,
  fa_name_en,
  fa_name_kana,
  organize_id,
  evadist_municip_code: ju_municip_code,
  fa_address,
  fa_address_en,
  ju_municip_code,
  fa_phone,
  fa_fax,
  fa_mail_address,
  fa_latitude,
  fa_longitude,
  fa_distance_from_npp,
  fa_direction_from_npp,
  fa_respons_person,
  max_capacity,
  max_household,
  lodine_distri_place_flg,
  temp_facility_flg,
  eva_area_info: edited_eva_area_info
    .filter(
      ({ eva_municip_code, eva_area_code }) => eva_municip_code && eva_area_code
    )
    .map(({ eva_municip_code, eva_area_code }) => ({
      eva_municip_code,
      eva_area_code
    })),
  hash
});

/**
 * 避難退域時検査場所の登録または更新リクエスト用のペイロードを作成する
 * @function
 * @param {object} editedItem 編集アイテム
 * @returns {object} ペイロード
 */
const toCreateOrUpdatePayloadForInspection = ({
  fa_id = undefined,
  fa_name = "",
  fa_name_en = "",
  fa_name_kana = "",
  organize_id = "",
  fa_address = "",
  fa_address_en = "",
  ju_municip_code = "",
  fa_phone = "",
  fa_fax = "",
  fa_mail_address = "",
  fa_latitude = "",
  fa_longitude = "",
  fa_distance_from_npp = "",
  fa_direction_from_npp = "",
  fa_respons_person = "",
  lanes = "",
  lodine_distri_place_flg = "",
  temp_facility_flg = "",
  hash = undefined
} = {}) => ({
  facility_class: FacilityClass.INSPECTION, // 避難退域時検査場所
  fa_id,
  fa_name,
  fa_name_en,
  fa_name_kana,
  organize_id,
  evadist_municip_code: ju_municip_code,
  fa_address,
  fa_address_en,
  ju_municip_code,
  fa_phone,
  fa_fax,
  fa_mail_address,
  fa_latitude,
  fa_longitude,
  fa_distance_from_npp,
  fa_direction_from_npp,
  fa_respons_person,
  lanes,
  lodine_distri_place_flg,
  temp_facility_flg,
  hash
});

/**
 * 原子力防災施設区分毎のペイロード作成関数
 */
const PAYLOAD_CONVERTERS = {
  [FacilityClass.SHELTER]: toCreateOrUpdatePayloadForShelter,
  [FacilityClass.MEETING]: toCreateOrUpdatePayloadForMeeting,
  [FacilityClass.INSPECTION]: toCreateOrUpdatePayloadForInspection
};

/**
 * 登録または更新リクエスト用のペイロードを作成する
 * @function
 * @param {object} editedItem 編集アイテム
 * @param {object} [converters=PAYLOAD_CONVERTERS] 原子力防災施設区分毎のペイロード作成関数
 * @returns {object} ペイロード
 */
const toCreateOrUpdatePayload = (
  { facility_class, ...rest },
  converters = PAYLOAD_CONVERTERS
) => converters[facility_class](rest);

export default {
  mixins: [messageUtils],

  components: {
    ConfirmDialog,
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    EvaAreaInfo: () => import("@/components/facility/EvaAreaInfo"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },

  data: () => ({
    config: config,
    overlay: false,
    loading: false,
    dialog: false,
    valid: false,
    screenTitle: "",
    screenId: "",
    readOnly: false,
    // 検索項目
    searchItem: {
      // 原子力防災施設区分
      facilityClass: FacilityClass.SHELTER,
      // 臨時施設区分
      tempFacilityFlag: "",
      // 避難元所属市町村または市町村
      municipality: "",
      // 避難元所属地域（地区）
      area: "",
      // 未設定項目がある施設のみ表示
      showsUnsetOnly: false,
      // 安定ヨウ素剤配布場所のみ表示
      showsDistriPlaceOnly: false,
      // フリーテキスト
      freeText: ""
    },
    // 組織リスト
    organizations: [],
    // 原子力防災施設区分マスタリスト
    items: [],
    // 編集中の原子力防災施設区分マスタリストのインデックス(新規の場合は、-1)
    editedIndex: -1,
    // 編集中の原子力防災施設区分マスタ
    editedItem: createEditedItem()
  }),

  mounted() {
    this.pageTitle(this.screenTitle);
  },

  computed: {
    /**
     * フォームの検証ルール
     */
    rules() {
      return getRules();
    },

    /**
     * 一覧表のヘッダー
     */
    headers() {
      return getHeaders(this.searchItem.facilityClass);
    },

    /**
     * 編集中のアイテムが新規登録かどうかを示す値
     */
    isNewEditedItem() {
      return this.editedIndex === -1;
    },

    /**
     * 避難元所属地域検索項目を表示するかどうかを示す値
     */
    showsArea() {
      return (
        this.searchItem.facilityClass === FacilityClass.SHELTER ||
        this.searchItem.facilityClass === FacilityClass.MEETING
      );
    },

    /**
     * 表を表示するかどうかを示す値
     */
    showsDataTable() {
      return !!this.searchItem.municipality && !!this.searchItem.facilityClass;
    },

    /**
     * 未設定項目の判定対象の属性名
     */
    unsetTargets() {
      return Object.fromEntries(
        FacilityClass.evaFacilityClasses().map(facilityClass => [
          facilityClass,
          getUnsetTargets(facilityClass)
        ])
      );
    },

    /**
     * アイテム毎の未設定項目判定結果
     * unsetItemFlags[n]は、items[n]の判定結果を保持する。
     */
    unsetItemFlags() {
      return this.items.map(
        item =>
          !item.fa_id.startsWith("ZZ") &&
          this.unsetTargets[item.facility_class].some(({ name, criteria }) =>
            criteria(item[name])
          )
      );
    },

    /**
     * 未設定項目のあるアイテムが存在するかどうか
     */
    hasUnsetItem() {
      return this.unsetItemFlags.some(flag => flag);
    },

    /**
     * フリーテキストの検索対象の属性名リスト
     */
    freeTextTargets() {
      return [
        "fa_name",
        "fa_name_kana",
        "fa_name_en",
        "fa_address",
        "fa_respons_person"
      ];
    },

    /**
     * 検索項目によってフィルタしたアイテムリスト
     */
    filteredItems() {
      // 常にTrue/Falseを返す関数
      const alwaysTrue = () => true;
      const alwaysFalse = () => false;

      // 施設IDフィルタ(ZZで始まる施設IDは画面表示しない)
      const faIdFilter = () => item => !item.fa_id.startsWith("ZZ");

      // 原子力防災施設区分フィルタ（未指定の場合は常にFalse）
      const facilityClassFilter = facilityClass =>
        facilityClass
          ? item => item.facility_class === facilityClass
          : alwaysFalse;

      // 臨時施設区分フィルタ
      const tempFacilityFilter = tempFacilityFlag =>
        tempFacilityFlag
          ? item => item.temp_facility_flg === tempFacilityFlag
          : alwaysTrue;

      // 避難元所属地区フィルタ（未指定の場合は常にTrue）
      const areaFilter = area =>
        area ? item => item.eva_area_code_list?.includes(area) : alwaysTrue;

      // 未設定項目フィルタ（未設定の場合は常にTrue）
      const unsetFilter = showsUnsetOnly =>
        showsUnsetOnly
          ? item => this.unsetItemFlags[this.items.indexOf(item)]
          : alwaysTrue;

      // 安定ヨウ素剤配布場所フィルタ（未設定の場合は常にTrue）
      const distriPlaceFilter = showsDistriPlaceOnly =>
        showsDistriPlaceOnly
          ? item => item.lodine_distri_place_flg === "1" // 配布場所
          : alwaysTrue;

      // フリーテキストフィルタ（未指定の場合は常にTrue）
      const freeTextFilter = freeText =>
        freeText
          ? item =>
              this.freeTextTargets.some(name => item[name]?.includes(freeText))
          : alwaysTrue;

      // 各フィルタを適用
      return this.items
        .filter(faIdFilter())
        .filter(facilityClassFilter(this.searchItem.facilityClass))
        .filter(tempFacilityFilter(this.searchItem.tempFacilityFlag))
        .filter(areaFilter(this.searchItem.area))
        .filter(unsetFilter(this.searchItem.showsUnsetOnly))
        .filter(distriPlaceFilter(this.searchItem.showsDistriPlaceOnly))
        .filter(freeTextFilter(this.searchItem.freeText));
    },

    /**
     * 市町村のリスト
     */
    municipalities() {
      const municipalities = this.$store.state.allArea?.municipalities;
      if (municipalities && Array.isArray(municipalities)) {
        return municipalities;
      }

      return [];
    },

    /**
     * 市町村のリスト（一覧取得）
     */
    municipalitiesAddAll() {
      const municipalities = this.$store.state.allArea?.municipalities;
      if (municipalities && Array.isArray(municipalities)) {
        return [{ text: "すべて", value: "all" }, ...municipalities];
      }

      return [];
    },

    /**
     * 地域（地区）のリスト
     */
    areas() {
      const areas = this.$store.state.allArea?.areas;
      if (areas && Array.isArray(areas)) {
        return AllAreaTranslator.toAreasByMunicipality(
          this.$store.state.allArea?.areas ?? [],
          this.searchItem.municipality
        );
      }

      return [];
    },

    /**
     * 原子力防災施設区分毎の編集項目属性名リストを保持するオブジェクト
     */
    editableAttributes() {
      return Object.fromEntries(
        FacilityClass.evaFacilityClasses().map(facilityClass => [
          facilityClass,
          getEditableAttributes(facilityClass)
        ])
      );
    },

    /**
     * デフォルトの編集項目属性名リスト
     */
    defaultEditableAttributes() {
      return getEditableAttributes();
    },

    /**
     * 指定された属性が編集対象がどうかを示す関数
     */
    isEditable() {
      const currentFacilityClass = this.editedItem.facility_class;

      return attributeName =>
        (
          this.editableAttributes[currentFacilityClass] ??
          this.defaultEditableAttributes
        ).includes(attributeName);
    },

    /**
     * フォームコントロール用の属性作成関数
     */
    formControlProps: () => {
      return function(
        placeholder = config.PLACEHOLDER_SP,
        counter = null,
        hint = null
      ) {
        const formControlProps = this.$formControlProps(
          this.readOnly,
          counter,
          true,
          hint
        );

        if (this.readOnly) {
          placeholder = config.PLACEHOLDER_SP;
        }

        formControlProps.placeholder = placeholder;
        formControlProps.readonly = formControlProps.disabled;
        delete formControlProps.disabled;

        return formControlProps;
      };
    }
  },

  watch: {
    $route: "initialize",

    /**
     * ダイアログの表示を監視
     */
    dialog(value) {
      if (value) {
        this.openEditDialog();
      }
    },

    /**
     * 検索項目の変更を監視
     */
    searchItem: {
      handler() {
        this.resetPage();
      },
      deep: true
    },

    /**
     * 検索項目の原子力防災施設区分の変更を監視
     */
    "searchItem.facilityClass": function() {
      this.searchItem.area = "";
    },

    /**
     * 検索項目の市町村の変更を監視
     */
    "searchItem.municipality": async function() {
      this.overlay = true;
      try {
        this.searchItem.area = "";
        await this.refreshItems();
      } catch (e) {
        this.handleGetError(e);
      } finally {
        this.overlay = false;
      }
    },

    /* 緯度、経度テキストボックスの変更を監視 */
    "editedItem.fa_latitude": function() {
      this.returnDistance();
      this.returnDirection();
    },
    "editedItem.fa_longitude": function() {
      this.returnDistance();
      this.returnDirection();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    /**
     * コンポーネントを初期化する。
     */
    async initialize() {
      this.overlay = true;
      try {
        // 操作権限
        const screen = this.$screenOperationAuthority(
          ScreenId.SF1401,
          ScreenId.SF1402
        );
        this.screenId = screen.screenId;
        this.readOnly = screen.readOnly;
        this.screenTitle = screen.screenTitle;

        // 市町村
        await this.$store.dispatch("allArea/loadAllArea");

        // 組織
        this.organizations = await fetchOrganizations(this.screenId);
      } catch (error) {
        this.handleError(error, this.screenId, "aggregation-menu");
      } finally {
        this.overlay = false;
      }
    },

    /**
     * 市町村名を取得
     */
    municipalityNames(item) {
      if (
        FacilityClass.factory(
          this.searchItem.facilityClass
        ).isShelterOrMeeting()
      ) {
        return this.$facility.evaMunicipalityNamesForDataTableItems(
          item.eva_municip_code_list,
          this.municipalities
        );
      }
      return this.$facility.getNameFromItems(
        item.ju_municip_code,
        this.municipalities
      );
    },

    /**
     * 地域名を取得
     */
    areaNames(item) {
      if (
        FacilityClass.factory(
          this.searchItem.facilityClass
        ).isShelterOrMeeting()
      ) {
        return this.$facility.evaAreaNamesForDataTableItems(
          item.eva_area_code_list,
          this.$store.state.allArea.areas
        );
      }
      return "";
    },

    /**
     * 原子力防災施設区分に応じて
     * "市町村" / "避難元所属市町村"
     * を取得する
     */
    municipalityTitle(facilityClass) {
      if (FacilityClass.factory(facilityClass).isShelterOrMeeting()) {
        return "避難元所属市町村";
      }
      return "市町村";
    },

    /**
     * 原子力防災施設区分に応じて
     * "地域（地区）" / "避難元所属地域（地区）"
     * を取得する
     */
    areaTitle(facilityClass) {
      if (FacilityClass.factory(facilityClass).isShelterOrMeeting()) {
        return "避難元所属地域（地区）";
      }
      return "地域（地区）";
    },

    /**
     * 指定された原子力防災施設区分が避難所がどうかを判定する
     */
    isShelter(facilityClass) {
      if (!facilityClass) {
        return false;
      }

      return FacilityClass.factory(facilityClass).isShelter();
    },

    /**
     * 選択中の市町村にしたがって、原子力災害関係施設マスタを取得する。
     */
    async refreshItems() {
      if (!this.searchItem.municipality) {
        this.items = [];
      } else {
        this.items = await fetchDisasterFacilities(
          this.screenId,
          this.searchItem.municipality
        );
      }
    },

    /**
     * ダウンロードボタンのクリックイベントを処理する。
     */
    async handleDownload() {
      this.overlay = true;
      try {
        const records = (await fetchDisasterFacilities(this.screenId))
          .map(addEmptyEvaAreaInfoIfNeeded)
          .flatMap(flatternEvaAreaInfo);
        const sorted = [...records].sort(csvSorter);

        const matrix = [
          CSV_FIELDS.map(({ name }) => name),
          ...sorted.map(toCSVColArray())
        ];

        fileDownload(
          new Blob([getCSVFormatter()(matrix)], {
            type: "text/csv"
          }),
          `原子力災害関係施設マスタ_${getTimestamp()}.csv`
        );
      } finally {
        this.overlay = false;
      }
    },

    /**
     * 参照ボタンのクリックイベントを処理する。
     */
    handleView(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = convertEditable(item);
      this.openEditDialog();
    },

    /**
     * 編集ボタンのクリックイベントを処理する。
     */
    handleEdit(item) {
      // 編集中アイテムのインデックスを取得
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = convertEditable(item);
      this.openEditDialog();
    },

    /**
     * 削除ボタンのクリックイベントを処理する。
     */
    async handleDelete(item) {
      this.clearMessage();

      const messages = [
        "削除した場合には元に戻せません。本当によろしいですか？"
      ];
      for (let message of messages) {
        if (!(await this.showConfirmDialog("削除", message))) {
          return;
        }
      }

      this.overlay = true;
      try {
        // 原子力防災関係施設マスタを削除して再取得
        this.handleSuccess(await this.deleteRecord(item));
        await this.refreshItems();
      } catch (error) {
        this.handleUpdateError(error);
      } finally {
        this.overlay = false;
      }
    },

    /**
     * 編集ダイアログの登録または更新ボタンクリックイベントを処理する。
     */
    async handleSaveEditDialog() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.$refs.evaAreaInfo && !this.$refs.evaAreaInfo.validate()) {
        return;
      }

      this.clearMessage();
      this.overlay = true;
      this.loading = true;
      try {
        // 原子力防災関係施設マスタを登録または更新して再取得
        if (this.isNewEditedItem) {
          this.handleSuccess(await this.createRecord());
        } else {
          this.handleSuccess(await this.updateRecord());
        }

        await this.refreshItems();
      } catch (e) {
        this.handleUpdateError(e);
      } finally {
        this.closeEditDialog();
        this.overlay = false;
        this.loading = false;
      }
    },

    /**
     * 編集ダイアログのキャンセルまたは戻るボタンクリックイベントを処理する。
     */
    handleCloseEditDialog() {
      this.closeEditDialog();
    },

    /**
     * 編集ダイアログを開く
     */
    openEditDialog() {
      this.dialog = true;

      this.$nextTick(() => {
        // スクロールのリセット
        const elements = document.getElementsByClassName("v-dialog--active");
        if (elements && elements.length > 0) {
          elements[0].scrollTop = 0;
        }

        // バリデーションのリセット
        this.$refs.form.resetValidation();
      });
    },

    /**
     * 編集ダイアログを閉じる
     */
    closeEditDialog() {
      this.dialog = false;
      this.$refs.form.resetValidation();

      this.$nextTick(() => {
        this.editedIndex = -1;
        this.editedItem = createEditedItem();
      });
    },

    /**
     * 原子力防災関係施設マスタを登録する。
     */
    async createRecord() {
      return await disasterPreventionFaRepository.create(
        this.screenId,
        toCreateOrUpdatePayload(this.editedItem)
      );
    },

    /**
     * 原子力防災関係施設マスタを更新する。
     */
    async updateRecord() {
      return await disasterPreventionFaRepository.update(
        this.screenId,
        toCreateOrUpdatePayload(this.editedItem)
      );
    },

    /**
     * 原子力防災関係施設マスタを削除する。
     * @param {Object} item 削除するアイテム
     */
    async deleteRecord(item) {
      return await disasterPreventionFaRepository.delete(this.screenId, {
        fa_id: item.fa_id,
        hash: item.hash
      });
    },

    /**
     * 確認ダイアログを表示する。
     * @param {string} buttonText ボタンに表示するテキスト
     * @param {...string} messages メッセージ
     * @returns {boolean} キャンセルされていないかどうかを示す値。
     */
    async showConfirmDialog(buttonText, ...messages) {
      return await this.$refs.confirmDialog.open(messages, buttonText);
    },

    /**
     * 一覧表のページネーションをリセット
     */
    resetPage() {
      this.$refs.table?.resetPage();
    },

    /* calculateDistance()の結果を返す */
    returnDistance() {
      const lat = this.editedItem.fa_latitude;
      const lng = this.editedItem.fa_longitude;

      // 緯度・経度が空でないかつ、0より大きいかをチェック
      if (lat !== "" && lng !== "" && Number(lat) > 0 && Number(lng) > 0) {
        this.editedItem.fa_distance_from_npp = this.calculateDistance(lat, lng);
      } else {
        this.editedItem.fa_distance_from_npp = ""; // 空または0以下ならクリア
      }
    },

    /* calculateBearing()の結果を返す */
    returnDirection() {
      const lat = this.editedItem.fa_latitude;
      const lng = this.editedItem.fa_longitude;

      // 緯度・経度が空でないかつ、0より大きいかをチェック
      if (lat !== "" && lng !== "" && Number(lat) > 0 && Number(lng) > 0) {
        this.editedItem.fa_direction_from_npp = this.calculateBearing(lat, lng);
      } else {
        this.editedItem.fa_direction_from_npp = ""; // 空または0以下ならクリア
      }
    },

    /* 緯度・経度から距離を計算*/
    calculateDistance(latitude, longitude) {
      /* 避難元の緯度、経度 */
      const latitude1 = latitude;
      const longitude1 = longitude;
      /* 原発の緯度、経度 */
      const latitude2 = Number(process.env.VUE_APP_NUCLEAR_POWER_PLANT_LAT);
      const longitude2 = Number(process.env.VUE_APP_NUCLEAR_POWER_PLANT_LON);

      const diffLatitudeRadian = ((latitude2 - latitude1) * Math.PI) / 180;
      const diffLongitudeRadian = ((longitude2 - longitude1) * Math.PI) / 180;
      const latitudeRadian = (latitude1 * Math.PI) / 180;
      const longitudeRadian = (latitude2 * Math.PI) / 180;
      const a =
        Math.sin(diffLatitudeRadian / 2) * Math.sin(diffLatitudeRadian / 2) +
        Math.sin(diffLongitudeRadian / 2) *
          Math.sin(diffLongitudeRadian / 2) *
          Math.cos(latitudeRadian) *
          Math.cos(longitudeRadian);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const calculateResult = EARTH_RADIUS * c;
      const result = Math.floor(calculateResult * 10) / 10;
      return result;
    },

    /*緯度経度から方角を計算*/
    calculateBearing(latitude, longitude) {
      /* 避難元の緯度、経度 */
      const latitude1 = latitude;
      const longitude1 = longitude;
     /* 原発の緯度、経度 */
      const latitude2 = Number(process.env.VUE_APP_NUCLEAR_POWER_PLANT_LAT);
      const longitude2 = Number(process.env.VUE_APP_NUCLEAR_POWER_PLANT_LON);

      /* ラジアンに変換 */
      const toRadians = deg => (deg * Math.PI) / 180;
      const toDegrees = rad => (rad * 180) / Math.PI;

      const diameter1 = toRadians(latitude2);
      const diameter2 = toRadians(latitude1);
      const difference = toRadians(longitude1 - longitude2);

      const y = Math.sin(difference) * Math.cos(diameter2);
      const x =
        Math.cos(diameter1) * Math.sin(diameter2) -
        Math.sin(diameter1) * Math.cos(diameter2) * Math.cos(difference);
      let angle = Math.atan2(y, x);
      angle = (toDegrees(angle) + 360) % 360; // 0〜360度に変換

      return this.bearingToCompass(angle);
    },

    /* 方角を数値から文字列に変換 */
    bearingToCompass(bearing) {
      directions;
      const index = Math.round(bearing / 22.5) % 16;
      return directions[index];
    }
  }
};
</script>
